import config from '@/config'
import { httpClientPrivate } from '@/libs/httpClient'
import { useQuery } from '@tanstack/react-query'
import { FilterOptionResponse } from '../types'

const fetchFilterOptionExaminer = async () => {
  const response = await httpClientPrivate.get<FilterOptionResponse[]>(
    `${config.restUrl}/v1/backoffice/e-claim/filter-option/examiner`,
  )

  return response.data
}

const useFilterOptionExaminer = () => {
  const queryKey = ['useFilterOptionExaminer']
  const queryFn = async () => fetchFilterOptionExaminer()
  const queryResult = useQuery({ queryKey, queryFn })

  return { ...queryResult }
}

export { fetchFilterOptionExaminer, useFilterOptionExaminer }
